<div *ngIf="showDialog">
<h2 mat-dialog-title class="mat-typography">{{ title }}</h2>

<div mat-dialog-content class="mat-typography">
  <mat-form-field appearance="fill" style="width: 100%;">
    <mat-label>{{ reportTitleLabel }}</mat-label>
    <input
      matInput
      [(ngModel)]="reportTitleLine1"
      maxlength="100"
      placeholder="{{ reportTitlePlaceHolder }}" />
    <mat-hint align="end">{{ reportTitleLine1?.length || 0 }} / 100</mat-hint>
  </mat-form-field>
  <div class="igo-input-container">
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>{{ 'sigt.integration.rechercheGdf.form.serviceGdf.mapCenterLabel' | translate }}</mat-label>
      <input
        type="text"
        tabindex="-1"
        matInput
        #inputRef
        (focus)="onInputFocus()"
        [(ngModel)]="mapCenterPoint.text"
        (keyup)="blockTyping($event)"
        (keydown)="blockTyping($event)"
      />
      <button
        *ngIf="mapCenterPoint.text"
        mat-icon-button
        matSuffix
        [matTooltip]="'igo.geo.directions.input.clearStop' | translate"
        color="warn"
        (click)="clearInput($event)"
      >
        <mat-icon>close</mat-icon>
      </button>
      <mat-hint>{{ 'sigt.integration.rechercheGdf.form.serviceGdf.mapCenterPlaceholder' | translate }}</mat-hint>
    </mat-form-field>
  </div>
  <div>&nbsp;</div>
  <mat-form-field appearance="fill" style="width: 100%;">
    <mat-label>{{ legendSelectorLabel }}</mat-label>
    <mat-select [(ngModel)]="selectedLegendId" (selectionChange)="onLegendChange($event.value)">
      <mat-option value="">{{ legendSelectorPlaceholder }}</mat-option>
      <mat-option *ngFor="let option of legendOptions" [value]="option.id">
        {{ option.title }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <img [src]="legendImageUrl" *ngIf="legendImageUrl" alt="Legend Image" />
</div>
<div mat-dialog-actions>
  <button mat-raised-button
    (click)="onCancel()">{{ buttonCancel }}</button>
  <button mat-raised-button
    color="primary"
    [disabled]="!selectedLegendId"
    (click)="onConfirm()">{{ buttonOk }}</button>
</div>
</div>